var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialmediaX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9908 17.1721L4 6H11.1213L16.6713 12.9051L22.6005 6.03109H26.5226L18.5676 15.2645L28 27H20.8999L14.8905 19.5326L8.47476 26.9793H4.53144L12.9908 17.1721ZM21.9348 24.93L8.36657 8.06999H10.0857L23.6368 24.93H21.9348Z",
    fill: "#A8A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaX);
export default __webpack_public_path__ + "static/media/socialmedia-x.d86d22912ca33e40db111e4abde6d572.svg";
export { ForwardRef as ReactComponent };